import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { InterviewResourceIdentifier, JhiLanguageHelper, LifeResourceIdentifier } from '@Components/mras/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LocationToIdentifierHelper {
    constructor(private langHelper: JhiLanguageHelper) {}

    public identifier: InterviewResourceIdentifier;
    public lifeResourceIdentifier: LifeResourceIdentifier;
    
    interviewResourceIdentifier(route: ActivatedRoute): Observable<InterviewResourceIdentifier> {
        return zip(
            route.paramMap.pipe(
                map(e => {
                    const identifier = new InterviewResourceIdentifier();
                    identifier.caseId = e.get('caseId');
                    identifier.lifeInstance = e.get('lifeInstance');
                    identifier.interviewCode = e.get('interviewCode');
                    return identifier;
                })
            ),
            route.queryParamMap.pipe(
                map(e => {
                    const identifier = new InterviewResourceIdentifier();
                    identifier.interviewInstance = e.get('interviewInstance');
                    return identifier;
                })
            ),
            this.langHelper.language.pipe(
                map(e => {
                    const identifier = new InterviewResourceIdentifier();
                    identifier.languageCode = e;
                    return identifier;
                })
            )
        ).pipe(
            map(zipped => {
                const merged = {} as InterviewResourceIdentifier;
                zipped.forEach(entry => Object.assign(merged, entry));
                return merged;
            })
        );
    }
}
